/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable, ApplicationRef } from '@angular/core';
import { IceNavService } from '../../../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { IceTypes } from '../../../icemedx-lib/src/models/icetypes';
import { LoginService } from '../../../icemedx-lib/src/login/login.service';
import { DomainAppService } from '../../../icemedx-lib/src/services/baseapp.service';
import { BreadcrumbService } from '../../../icemedx-lib/src/services/breadcrumb/breadcrumb.service';

@Injectable()
export class AppService extends DomainAppService {

  constructor(navSvc: IceNavService, domainSvc: DomainService, loginSvc: LoginService, app: ApplicationRef, breadcrumbSvc: BreadcrumbService) {
    super(navSvc, domainSvc, loginSvc, app, breadcrumbSvc);
  }

  public defaultMenus() {
    super.defaultMenus();

    let currActType = this.getCurrentAccountType();
    switch (currActType) {
      case IceTypes.ACCOUNT_TYPE.actPayer: {
        this.payerdomainMenus();
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actPharmacy: {
        this.pharmacydomainMenus();
        break;
      }
    }
  }
}
